"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weatherIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var WeatherIcon = _interopRequireWildcard(require("./icon-objects"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Clouds = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "clouds",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {})
  });
};

const LightRain = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fall rain",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "cloudy",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Sun, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "drops",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      })
    })]
  });
};

const ModerateRain = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fall rain",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "cloudy",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Sun, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "drops",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      })]
    })]
  });
};

const Rain = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fall rain",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "cloudy",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Sun, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "drops",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      })]
    })]
  });
};

const LightShowerRain = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fall rain",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "drops",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      })
    })]
  });
};

const ShowerRain = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fall rain",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "drops",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      })]
    })]
  });
};

const Cloudy = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "cloudy",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Sun, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {})]
  });
};

const Clear = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "clear",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Sun, {})
  });
};

const Thunderstorm = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "thunderstorm",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "thunder",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Flash, {})
    })]
  });
};

const ThunderstormRain = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "thunderstorm",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "drops",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Flash, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      })]
    })]
  });
};

const LightSnow = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fall snow",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "cloudy",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Sun, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "drops",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {})
    })]
  });
};

const HeavySnow = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fall snow",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "cloudy",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Sun, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "drops",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {})]
    })]
  });
};

const Snow = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fall snow",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "cloudy",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Sun, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "drops",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {})]
    })]
  });
};

const LightShowerSnow = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fall snow",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "drops",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {})
    })]
  });
};

const ShowerSnow = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fall snow",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "drops",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {})]
    })]
  });
};

const FreezingRain = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fall rain snow",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "drops",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      })]
    })]
  });
};

const SnowAndRain = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fall snow rain",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "drops",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "shape drop-shape"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Snowflake, {})]
    })]
  });
};

const Fog = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "fog",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "cloud-foggy",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Cloud, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(WeatherIcon.Mist, {})]
  });
};

const weatherIcon = {
  'Clear': /*#__PURE__*/(0, _jsxRuntime.jsx)(Clear, {}),
  'Clouds': /*#__PURE__*/(0, _jsxRuntime.jsx)(Clouds, {}),
  'Cloudy': /*#__PURE__*/(0, _jsxRuntime.jsx)(Cloudy, {}),
  'Rain': /*#__PURE__*/(0, _jsxRuntime.jsx)(Rain, {}),
  'LightRain': /*#__PURE__*/(0, _jsxRuntime.jsx)(LightRain, {}),
  'ModerateRain': /*#__PURE__*/(0, _jsxRuntime.jsx)(ModerateRain, {}),
  'ShowerRain': /*#__PURE__*/(0, _jsxRuntime.jsx)(ShowerRain, {}),
  'LightShowerRain': /*#__PURE__*/(0, _jsxRuntime.jsx)(LightShowerRain, {}),
  'Snow': /*#__PURE__*/(0, _jsxRuntime.jsx)(Snow, {}),
  'LightSnow': /*#__PURE__*/(0, _jsxRuntime.jsx)(LightSnow, {}),
  'HeavySnow': /*#__PURE__*/(0, _jsxRuntime.jsx)(HeavySnow, {}),
  'ShowerSnow': /*#__PURE__*/(0, _jsxRuntime.jsx)(ShowerSnow, {}),
  'LightShowerSnow': /*#__PURE__*/(0, _jsxRuntime.jsx)(LightShowerSnow, {}),
  'Thunderstorm': /*#__PURE__*/(0, _jsxRuntime.jsx)(Thunderstorm, {}),
  'ThunderstormRain': /*#__PURE__*/(0, _jsxRuntime.jsx)(ThunderstormRain, {}),
  'FreezingRain': /*#__PURE__*/(0, _jsxRuntime.jsx)(FreezingRain, {}),
  'SnowAndRain': /*#__PURE__*/(0, _jsxRuntime.jsx)(SnowAndRain, {}),
  'Fog': /*#__PURE__*/(0, _jsxRuntime.jsx)(Fog, {})
};
exports.weatherIcon = weatherIcon;